import * as actionTypes from "../actionTypes";

const initialState = {
    userData: [],
};

const userReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_USER: {
            return {
                ...state,
                userData: payload,
            };
        }
        default: {
            return state;
        }
    }
};

export default userReducer;
